import { ExcelOfApprovedCashFilter } from "../models/excel-of-approved-cash-filter";
import { PaymentItemsSearchRequest } from "../models/payment-reuqest-structure";

const queryFilterUtils = {
  buildNestForm: (obj: any[]) =>
    obj.filter((o) => o).map((o) => ({ id: +o.id, type: o.type.toString() })),
  buildEventForm: (obj: any[]) =>
    obj.map((o) => ({ id: +o.id, eventType: +o.eventType })),
  buildPaymentStatus: (obj: any): string[] =>
    obj.filter((o) => o).map((o) => o.toString()),
  buildLayerForm: (obj: any): number[] => obj.map((o) => +o),
};

export const customQueryFilters = {
  ExcelOfApprovedCash: (rawFilterFromComponent: any) => {
    try {
      let {
        // Properties that always exist

        layerForm,
        paymentTypeForm,
        nestForm,
        eventForm,
        isCurrentYearSelected,
        sumForm,
        dateForm,
        depositClosedDateForm,

        // Optional properties
        paymentStatus,
        childAndParent,
        childCountry,
        parentCountry,
        returnTypeValue,
        receiptIssuer,
        receiptNumberForm,
        items,

        // Properties that are not supported exist
        pageIndex,
        pageSize,
        countResults,
        unhandledReturns,
      } = rawFilterFromComponent;

      let customFilter: ExcelOfApprovedCashFilter = {
        filters: {
          layerForm: queryFilterUtils.buildLayerForm(layerForm || []),
          paymentTypeForm: queryFilterUtils.buildPaymentStatus(
            paymentTypeForm || []
          ),
          nestForm: queryFilterUtils.buildNestForm(nestForm || []),
          eventForm: queryFilterUtils.buildEventForm(eventForm || []),
          receiptIssuer: +receiptIssuer || null,
          items: +items ? [+items] : [],
          isCurrentYearSelected: isCurrentYearSelected || false,
          sumForm,
          dateForm,
          depositClosedDateForm,

          paymentStatus,
          childAndParent,
          childCountry,
          parentCountry,
          returnTypeValue,
          receiptNumberForm: (receiptNumberForm || "").toString(),
        },
      };
      return customFilter;
    } catch (err) {
      throw new Error(
        `ExcelOfApprovedCash failed - filter data was incorrect ${err}`
      );
    }
  },
  PaymentItemsSearchRequest: (rawFilterFromComponent: any) => {
    try {
      let {
        layerForm,
        paymentTypeForm,
        nestForm,
        eventForm,
        isCurrentYearSelected,
        sumForm,
        dateForm,
        depositClosedDateForm,

        // Optional properties
        paymentStatus,
        childAndParent,
        childCountry,
        parentCountry,
        returnTypeValue,
        receiptIssuer,
        receiptNumberForm,
        authNumberForm,
        noApproverComment,

        items,
        pageIndex,
        pageSize,
        // Properties that are not supported exist

        countResults,
        unhandledReturns,
      } = rawFilterFromComponent;
      const customFilter: PaymentItemsSearchRequest = {
        pageIndex,
        pageSize,
        filters: {
          authNumberForm: +authNumberForm || undefined,
          noApproverComment,
          layerForm: queryFilterUtils.buildLayerForm(layerForm || []),
          paymentTypeForm: queryFilterUtils.buildPaymentStatus(
            paymentTypeForm || []
          ),
          nestForm: queryFilterUtils.buildNestForm(nestForm || []),
          eventForm: queryFilterUtils.buildEventForm(eventForm || []),
          receiptIssuer: +receiptIssuer || null,
          items: +items ? [+items] : [],
          isCurrentYearSelected: isCurrentYearSelected || false,
          sumForm,
          dateForm,
          depositClosedDateForm,

          paymentStatus,
          childAndParent,
          childCountry,
          parentCountry,
          returnTypeValue,
          receiptNumberForm: (receiptNumberForm || "").toString(),
        },
      };
      // bypass for Dmey Haver event with no id by setting id as -1
      if (
        customFilter.filters &&
        customFilter.filters.eventForm.some((ev) => ev.eventType === 501)
      ) {
        customFilter.filters.eventForm = customFilter.filters.eventForm.map(
          (ev) => {
            if (ev.eventType === 501) {
              return { ...ev, id: -1 };
            }
            return ev;
          }
        );
      }

      return customFilter;
    } catch (err) {
      throw new Error(
        `ExcelOfApprovedCash failed - filter data was incorrect ${err}`
      );
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/admin/payments/custom-query/custom-query-filters.ts